import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconReactNative = ({
  title = "React Native",
  viewBoxWidth = 64,
  viewBoxHeight = 58,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g transform="translate(0 -3)" fill="none" fillRule="evenodd">
      <path d="M0 0h64v64H0z" />
      <circle fill="#000" fillRule="nonzero" cx="32" cy="31.574" r="5.707" />
      <path
        d="M32 44.647c-8.014 0-15.017-.944-20.257-2.74-3.4-1.16-6.287-2.706-8.344-4.468C1.216 35.575.057 33.54.057 31.574c0-3.774 4.138-7.469 11.083-9.879 5.684-1.978 13.096-3.08 20.849-3.08 7.616 0 14.925 1.068 20.575 3.023 3.308 1.137 6.093 2.615 8.071 4.252 2.149 1.796 3.285 3.763 3.285 5.684 0 3.922-4.626 7.889-12.083 10.356-5.275 1.75-12.323 2.717-19.837 2.717zm0-23.304c-7.355 0-14.63 1.068-19.95 2.921-6.389 2.228-9.254 5.275-9.254 7.31 0 2.114 3.081 5.445 9.833 7.752C17.586 41.02 24.293 41.918 32 41.918c7.23 0 13.97-.91 18.984-2.58 7.014-2.33 10.22-5.661 10.22-7.764 0-1.08-.819-2.353-2.308-3.592-1.717-1.433-4.217-2.74-7.207-3.775C46.312 22.366 39.32 21.343 32 21.343z"
        fill="#000"
        fillRule="nonzero"
      />
      <path
        d="M19.052 60.016c-1.16 0-2.182-.25-3.046-.75-3.263-1.888-4.4-7.321-3.024-14.54 1.125-5.922 3.876-12.88 7.753-19.598 3.808-6.593 8.378-12.39 12.89-16.312 2.638-2.297 5.31-3.98 7.72-4.866 2.625-.966 4.899-.966 6.558-.011 3.4 1.955 4.525 7.957 2.933 15.642-1.125 5.456-3.808 12.038-7.56 18.552-4 6.934-8.32 12.527-12.492 16.176-2.706 2.365-5.49 4.092-8.037 4.99-1.33.478-2.58.717-3.695.717zm2.854-34.206l1.182.682c-3.672 6.366-6.389 13.198-7.435 18.746-1.262 6.65-.045 10.651 1.705 11.663.432.25 1 .386 1.694.386 2.262 0 5.82-1.432 9.936-5.024 3.944-3.445 8.07-8.81 11.924-15.483 3.615-6.263 6.184-12.561 7.253-17.733 1.489-7.242.204-11.675-1.626-12.732-.932-.535-2.444-.466-4.263.204-2.103.773-4.478 2.285-6.866 4.366-4.285 3.728-8.662 9.276-12.322 15.619l-1.182-.694z"
        fill="#000"
        fillRule="nonzero"
      />
      <path
        d="M44.948 60.05c-3.092 0-7.014-1.865-11.106-5.389-4.57-3.933-9.22-9.787-13.107-16.505-3.82-6.594-6.548-13.448-7.696-19.325-.671-3.433-.796-6.582-.364-9.117.477-2.763 1.603-4.73 3.274-5.696 3.387-1.966 9.15.057 15.017 5.275 4.16 3.695 8.525 9.31 12.288 15.813 4.013 6.934 6.707 13.47 7.775 18.904.694 3.524.808 6.798.319 9.458-.523 2.83-1.705 4.842-3.41 5.831-.853.5-1.865.75-2.99.75zM23.099 36.79c3.683 6.366 8.253 12.13 12.527 15.802 5.127 4.41 9.197 5.365 10.959 4.342 1.83-1.057 3.171-5.388 1.784-12.39-1.023-5.139-3.603-11.391-7.468-18.064-3.626-6.264-7.798-11.64-11.743-15.142-5.525-4.91-10.003-6.013-11.834-4.956-.932.534-1.625 1.887-1.955 3.797-.375 2.205-.261 5.024.352 8.128 1.092 5.581 3.706 12.14 7.378 18.483z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </Svg.Icon>
)

export default IconReactNative
